export function formatDate(iso: string): string {
  try {
    const d = new Date(iso)
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
  } catch { return iso }
}

export function formatRelative(iso: string): string {
  try {
    const d = new Date(iso).getTime()
    const now = Date.now()
    const diff = Math.floor((now - d) / 1000)
    if (diff < 60)      return 'Vừa xong'
    if (diff < 3600)    return `${Math.floor(diff / 60)} phút trước`
    if (diff < 86400)   return `${Math.floor(diff / 3600)} giờ trước`
    if (diff < 604800)  return `${Math.floor(diff / 86400)} ngày trước`
    return formatDate(iso)
  } catch { return iso }
}
